<template>
	<div class="fuel container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="" v-if="!isChildRoute">
			<!--
			<div class="row">
				<div class="col-md-6 form-group">
					<ReportParamSearch title="Search Location" v-model="stationid" :options="spbu.list" fldid="StationId" fldinfo="StationName" />
				</div>
				<div class="col-md-2 form-group">
					<ReportParamSelect title="Tol" name="lokasi" v-model="lokasi" :options="options.lokasi" />
				</div>
				<div class="col-md-2 form-group">
					<ReportParamSelect title="Area" name="area" v-model="area" :options="options.area" />
				</div>
			</div>
			-->
			<div class="row mb-3">
				<div class="col-md-12 text-right">
					<!--<el-skeleton-item variant="text" style="width: 200px;" v-if="false" animated/>-->
					<el-link @click="dialogPicVisible = true"><i class="fa fa-whatsapp"></i>&nbsp;&nbsp;Contact Person PIC SATGAS</el-link>
					<!--<el-skeleton-item variant="text" style="width: 150px; margin-left:30px;" animated/>	-->
					<el-link @click="sprintPDF" style="margin-left:30px;" v-if="false"><i class="fa fa-file-pdf-o"></i>&nbsp;&nbsp;Sprint SATGAS PDF</el-link>
				</div>
			</div>

			<el-dialog title="PIC SATGAS" :visible.sync="dialogPicVisible" custom-class="dialog-pic-satgas">
				<hr style="border:1px solid #e9ecef;margin-top:-30px;margin-bottom:10px;">
				<el-table :data="satgasPic" stripe :height="tablePICHeight">
					<el-table-column property="Name" label="Name" width="150" fixed></el-table-column>
					<el-table-column property="MOR" label="MOR" :align="'center'" >
						<template slot-scope="scope">
							{{ morValue(scope.row.MOR) }}
						</template>
					</el-table-column>
					<el-table-column property="Function" label="Function"></el-table-column>
					<!--<el-table-column property="PhoneNumber" label="Phone Number"></el-table-column>-->
					<el-table-column
						property="PhoneNumber"
						label="Phone Number"
						width="160">
						<template slot-scope="scope">
							<a class="el-link el-link--success is-underline" :href="'https://wa.me/62'+scope.row.PhoneNumber.substring(1)" target="_blank"> <i class="fa fa-whatsapp" style="font-size:16px;">&nbsp;&nbsp;</i> <span class="el-link--inner" style="font-size:16px;"><b>{{ scope.row.PhoneNumber }}</b></span></a>
						</template>
					</el-table-column>

				</el-table>
				<Loader v-if="loading.pic" />
			</el-dialog>

			<el-form label-position="top" label-width="100px" style="padding:0px;">
			<div class="row">
				<div class="col-md-5">
					<el-form-item label="Location:">
						<el-select v-model="stationid" clearable filterable placeholder="Select Location" size="medium" style="width:100%;">
							<el-option v-for="item3 in spbu.list" :key="item3.StationId" :label="item3.StationName" :value="item3.StationId">
							</el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="col-md-3">
					<el-form-item label="Tol">
						<el-radio-group v-model="lokasi" size="small">
							<el-radio-button :label="item5.value" v-for="(item5, index5) in options.lokasi" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</div>
				<div class="col-md-4" v-if="false">
					<el-form-item label="Area">
						<el-radio-group v-model="area" size="small">
							<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</div>
				<div class="col-md-4">
					<el-form-item label="Region">
						<el-radio-group v-model="region" size="small">
							<el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</div>
			</div>
			</el-form>

			<div class="row mb-4">
				<PetaGmap :zoom="this.zoom" :centeringMap="centeringMap" :stationListMap="this.stationListMap" @pilihStationDariGmap="pilihStationDariGmap" />
				<Loader style="position: relative; height:400px;margin-top:-400px;" v-if="loading.tableStation && this.stationListMap.length>0" />
			</div>

			<div class="row mb-0">
				<div class="col-md-12">
					<div class="card cardptpr mb-4">
						<div class="card-header p-3 pb-0 pt-0">
							<H6>STATION LIST SATGAS MODULAR</H6>
						</div>
						<div class="card-body p-3 pt-0">
							<ReportResultTable class="table-station-satgas" reportname="StationList" :reportdata="reportdata" select_url="/plantSatgas?station=" idcol="StationId" noxls=1 :loading="loading.tableStation" />
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-4 mb-4">
					<div class="card cardptpr">
						<div class="card-header p-3 pb-0 pt-0 text-center">
							<H6>TANK STATUS</H6>
						</div>
						<div class="card-body p-3 pt-0" style="width:100%;">
							<div class="h-100 d-flex align-items-center justify-content-center pt-2 pb-2 ">
								<PieChart :data="this.statusgrouppie" style="width:100%;" />
								<div style="position:absolute;" v-if="statusgrouppie.length <= 0">No Data Available</div>
								<Loader v-if="loading.tableStation"/>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-4 mb-4">
					<div class="card cardptpr">
						<div class="card-header p-3 pb-0 pt-0 text-center">
							<H6>ATG STATUS</H6>
						</div>
						<div class="card-body p-3 pt-0" style="width:100%;">
							<div class="h-100 d-flex align-items-center justify-content-center pt-2 pb-2 ">
								<PieChart :data="this.statusatggrouppie" style="width:100%;" />
								<div style="position:absolute;" v-if="statusatggrouppie.length <= 0">No Data Available</div>
								<Loader v-if="loading.tableStation"/>
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-4 mb-4">
					<div class="card cardptpr">
						<div class="card-header p-3 pb-0 pt-0 text-center">
							<H6>KONDISI PEKERJA (FIT & UNFIT)</H6>
						</div>
						<div class="card-body p-3 pt-0" style="width:100%;">
							<div class="h-100 d-flex align-items-center justify-content-center pt-2 pb-2 ">
								<PieChart :data="this.piechartpekerja" style="width:100%;" />
								<div style="position:absolute;" v-if="piechartstatuspekerjadata.length <= 0">No Data Available</div>
								<Loader v-if="loading.piechartstatuspekerja"/>
							</div>
						</div>
					</div>
				</div>

			</div>

			<div class="row">
				<div class="col-md-12" >
					<BarLineCard title="SALES SATGAS MODULAR (KL) (LAYANAN TAMBAHAN)" :data="salesdata" :width="500" :height="400" :loading="loading.salesWeeklySatgas"/>
				</div>
			</div>
			<!-- <div class="row">
				<div class="col-md-6">
					<div class="card-body p-3 pt-0" style="width:280px;">
					<ListItem class=" mb-4" warning=1 title="CRITICAL STOCK BY PRODUCT" :data="critical.product" itemcol="ProductName" valuecol="Cnt"
							url="/fuel/report2?tab=3&status=CRITICAL&detail2=product&satgas=1"/>
					</div>
				</div>
			</div> -->
			<div class="row">
				<div class="col-md-12">
					<BarCard title="SALES DAILY BBK KEMASAN SATGAS (L) (LAYANAN TAMBAHAN)" :data="salesbbkkemasansatgas" :width="500" :height="400" :loading="loading.salesDailybbk"/>
				</div>
			</div>

			<div class="row mb-4">
				<div class="col-md-12">
					<div class="card cardptpr mb-4">
						<div class="card-header p-3 pb-0 pt-0">
							<H6>SALES BBK (LAYANAN TAMBAHAN)</H6>
						</div>
						<div class="card-body p-3 pt-0">
							<ReportResultTable reportname="Salesbbk" :reportdata="reportsalesbbkdata" select_url="" idcol="StationId" noxls=1 />
						</div>
					</div>

				</div>
			</div>

            <div class="row">
				<div class="col-md-12" >
					<BarLineCard title="SALES SPBU SATGAS NON TOL (KL) (LAYANAN TAMBAHAN)" :data="salesnontolbfsatgas" :width="500" :height="400" :loading="loading.salesbfSatgasNonTol"/>
				</div>
			</div>

            <div class="row">
				<div class="col-md-12">
					<BarLineCard title="SALES SPBU SATGAS TOL (KL) (LAYANAN TAMBAHAN)" :data="salestolbfsatgas" :width="500" :height="400" :loading="loading.salesbfSatgasTol"/>
				</div>
			</div>


			<div class="row" v-if="false">
				<div class="col-md-12" >
					<BarCard title="SALES SPBU 18 DAYS BEFORE SATGAS NON TOL (KL)" :data="salesnontolbfsatgas" :width="500" :height="400" :loading="loading.salesbfSatgasNonTol"/>
				</div>
			</div>

			<div class="row" v-if="false">
				<div class="col-md-12">
					<BarCard title="SALES SPBU SATGAS NON TOL (KL)" :data="salesnontolsatgas" :width="500" :height="400" :loading="loading.salesSatgasNonTol"/>
				</div>
			</div>

			<div class="row" v-if="false">
				<div class="col-md-12">
					<BarCard title="SALES SPBU 18 DAYS BEFORE SATGAS TOL (KL)" :data="salestolbfsatgas" :width="500" :height="400" :loading="loading.salesbfSatgasTol"/>
				</div>
			</div>

			<div class="row" v-if="false">
				<div class="col-md-12">
					<BarCard title="SALES SPBU SATGAS TOL (KL)" :data="salestolsatgas" :width="500" :height="400" :loading="loading.salesSatgasTol"/>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6 p-0">
					<div class="card-body p-3 pt-0"  style="margin-left: -4px;">
						<ListItem class=" mb-4" warning=1 :title="'SPBU NOT UPDATE (' + (this.shiftnotupdate ? this.shiftnotupdate.length : 0) + ' DATA)'" :data="shiftnotupdate" itemcol="StationName" textvaluecol="MaxDate"/>
					</div>
				</div><!--
				<div class="col-md-6">
					<div class="card-body p-3 pt-0">
					<ListItem class=" mb-4" warning=1 title="CASH PICKUP NOT UPDATE" :data="pickupnotupdate" itemcol="StationName" textvaluecol="MaxDate"/>
					</div>
				</div>-->

			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import BarCard from '@/views/pages/BarCard.vue'
import BarLineCard from '@/views/pages/BarLineCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ReportParamSearch from '@/views/pages/ReportParamSearch.vue'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import PetaGmap from '@/components/map/gmapSatgas.vue'
import Loader from '@/components/loader/Loader2.vue'
import PieChart from '@/components/chart/Pie.js'
import { AxiosWithJar, Config, Penanggalan, FuelColor, Rainbow} from '@/utility.js'

export default
{
	extends:Fuel,
	components: {
		//ReportParamSearch,
		//ReportParamSelect,
		ReportResultTable,
		ListItem,
		PieChart,
		PetaGmap,
		BarCard,
        BarLineCard,
		Loader,
	},
	computed:
	{
	},
	watch:
	{
		reportdata(){
			this.stationListMap = this.reportdata["data"]
				.filter(e=> e.Latitude!==null && e.Latitude!=="" && e.Longitude!==null && e.Longitude!=="")
				.map(item=>Object.assign(item,
					{id:item.StationId,name:item.StationName,lat:Number(item.Latitude.replace(',','.')),
					lng:Number(item.Longitude.replace(',','.')),Status:item.Status}))
		},
		stationid() {
			this.resumePilihan()
		},
		lokasi() {
			this.resumePilihan()
		},
		area() {
			this.resumePilihan()
		},
		region() {
			this.resumePilihan()
		},
        $route(to, from) {
            this.hideNonChildren();
        }
	},
	data(){
		return {
			tablePICHeight: 0,
			tabList:[
				{name:'Station'},
			],
			options: {
				lokasi:[
					{ value: "", name: "ALL" },
					{ value: "TOL", name: "TOL" },
					{ value: "NON TOL", name: "NON TOL" },
				],
				area:[
					{ value: "", name: "ALL" },
					//{ value: "area", name: "BY AREA", field: "SalesArea" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
				],
				region:[
					{ value: "", name: "ALL" },
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
					{ value: "6", name: "6" },
					{ value: "7", name: "7" },
				],
			},
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,
			showmap:false,
			stationid:"",
			reportdata:[],
			salesdata:[],
			reportsalesbbkdata:[],
			shiftnotupdate:[],
			pickupnotupdate:[],
			stationListMap:[],
			salesnontolbfsatgas:[],
			salesnontolsatgas:[],
			salestolbfsatgas:[],
			salestolsatgas:[],
			salesbbkkemasansatgas:[],
			piechartstatuspekerjadata: [],
			centeringMap:{},
			zoom:5,

			lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',
			area: this.$route.query.area ? this.$route.query.area : '',
			region: this.$route.query.region ? this.$route.query.region : '',
			loading: {
				tableStation: true,
				tablebbk: true,
				salesWeeklySatgas: true,
				salesDailybbk: true,
				salesbfSatgasNonTol: true,
				salesbfSatgasTol: true,
				salesSatgasNonTol: true,
				salesSatgasTol: true,
				spbuUpdate: true,
				pic: true,
				piechartstatuspekerja: true,

			},
			filePath: '',
			dialogPicVisible: false,
			satgasPic: [
				/*
				{
					Name: 'Rizki',
					Function: 'ICT',
					PhoneNumber: '08561995250',
				},
				{
					Name: 'Fajrin',
					Function: 'ICT',
					PhoneNumber: '082217688886'
				},
				{
					Name: 'Amin (MOR 1)',
					Function: 'ICT',
					PhoneNumber: '085262763290'
				},
				{
					Name: 'Fendi (MOR 2)',
					Function: 'ICT',
					PhoneNumber: '081273544188'
				}, */
			],

			statusgrouppie:[],
			statusatggrouppie:[],
			piechartpekerja: [],

            isChildRoute: false,
		}
	},
	mounted(){

		this.$emit('childrenRoute')
		this.loadStationList('SATGAS')
		this.resumePilihan()
		this.getSalesbbktable()
		this.getSalesbbk()
		this.getSalesbfsNonTol()
		this.getSalesNonTol()
		this.summarySatgas()
		this.loadSalesYTD();
		this.loadCritical(1);
		this.loadYTD();
		this.getFilePath();
		this.getSatgasPic();
		this.getStatusPekerjaFitUnfit()

		this.getTablePICHeight();
        this.hideNonChildren();
	},
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/satgas';
        },
        pilihStationDariGmap(stationId,PlantNo){
            let newtab = this.$router.resolve({ path: '/plantSatgas', query: { plant: PlantNo ,station: stationId } });
			window.open(newtab.href, '_blank')
        },
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')
		},

		async summarySatgas(){

			let url = ''

			//SALES SPBU 18 DAYS BEFORE SATGAS TOL (KL)
			url =Config().apiURL+"/v1/fuel2/salesbfsatgas?lokasi=TOL"
			/*
			url =Config().apiURL+"/fuel2/sales?period=daily&detail=product&lokasi=TOL"
				url += "&date-range-start=2022-12-01" //2022-04-01
				url += "&date-range-end=2022-12-18" //2022-04-17
				*/
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.salestolbfsatgas = this.processBarChart2(result.data.data, 'ProductName', 'SalesVolume', false, 'Period', 1000, 2, FuelColor,
						false, false, false, true, false, false, false, true)
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.salesbfSatgasTol = false;
			})

			//SALES SPBU SATGAS TOL (KL)
			url =Config().apiURL+"/v1/fuel2/salessatgas?lokasi=TOL"
			/*
			url =Config().apiURL+"/fuel2/sales?period=daily&detail=product&lokasi=TOL"
				url += "&date-range-start=2022-12-19" //2022-04-18
				url += "&date-range-end=2023-01-31"//+Penanggalan().kemarin
				*/
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.salestolsatgas = this.processBarChart2(result.data.data, 'ProductName', 'SalesVolume', false, 'Period', 1000, 2, FuelColor,
						false, false, false, true, false, false, false, true)
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.salesSatgasTol = false;
			})

			//old
			//url =Config().apiURL+"/v1/fuel2/checkshiftupdate?satgas=1&status=NOT+UPDATE"
			url =Config().apiURL+"/v1/fuel2/checkshiftupdatesatgas?satgas=1&status=NOT+UPDATE"
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.shiftnotupdate = result.data.data
				}
			})


			url =Config().apiURL+"/v1/fuel2/checkpickup?satgas=1"
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.pickupnotupdate = result.data.data
				}
			})


		},

		async getSalesbbktable() {
			//SALES DAILY BBK KEMASAN TABLE
			let url =Config().apiURL + '/v1/fuel2/salesbbk?'
			AxiosWithJar().get(url)
			.then((response)=>{
				this.reportsalesbbkdata = response.data;
			})
		},

		async getSalesbbk() {
			//SALES DAILY BBK KEMASAN SATGAS (PCS)
			let url =Config().apiURL+"/v1/Bright/salesbbksatgassummary"
			/*
			url =Config().apiURL+"/v1/Bright/salesbbksatgas?period=daily&detail=product"
				url += "&date-range-start=2022-12-19" //2022-04-18
				url += "&date-range-end=2023-01-31"//+Penanggalan().kemarin
				*/
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.salesbbkkemasansatgas = this.processBarChart(result.data.data, "ItemName", "", "Qty", false, "Period", " ", 1, 2, Rainbow)
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.salesDailybbk = false;
			})
		},

		async getSalesbfsNonTol() {
			//SALES SPBU 18 DAYS BEFORE SATGAS NON TOL
			let url =Config().apiURL+"/v1/fuel2/salesbfsatgas?lokasi=NON TOL"
			/*
			let url =Config().apiURL+"/fuel2/sales?period=daily&detail=product&lokasi=NON TOL"
				url += "&date-range-start=2022-12-01" //2022-04-01
				url += "&date-range-end=2022-12-18"	//2022-04-17
			*/
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.salesnontolbfsatgas = this.processBarChart2(result.data.data, 'ProductName', 'SalesVolume', false, 'Period', 1000, 2, FuelColor,
						false, false, false, true, false, false, false, true)
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.salesbfSatgasNonTol = false;
			})
		},

		async getSalesNonTol() {
			//SALES SPBU SATGAS NON TOL (KL)
			let url =Config().apiURL+"/v1/fuel2/salessatgas?lokasi=NON TOL"
			/*
			url =Config().apiURL+"/fuel2/sales?period=daily&detail=product&lokasi=NON TOL"
				url += "&date-range-start=2022-12-19" //2022-04-18
				url += "&date-range-end=2023-01-31"//+Penanggalan().kemarin
				*/
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.salesnontolsatgas = this.processBarChart2(result.data.data, 'ProductName', 'SalesVolume', false, 'Period', 1000, 2, FuelColor,
						false, false, false, true, false, false, false, true)
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.salesSatgasNonTol = false;
			})
		},

		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/v1/fuel2/station?satgas=1'

			this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&lokasi='+this.lokasi
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region

			this.loading.tableStation = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.reportdata = response.data;
					//console.log('reportdata : ' + JSON.stringify(response.data));

					this.generateStatusGroups(response.data.data)
					this.generateStatusATGGroups(response.data.data)
				})
				.catch(error => {
				//console.log('err: ' + error)
				})
				.finally(() => {
					this.loading.tableStation = false;
				})


			//SALES WEEKLY SATGAS
			let url =Config().apiURL+"/v1/fuel2/salesweeklysatgas"
			/*
			let url =Config().apiURL+"/v1/fuel2/sales?period=daily&detail=product&satgas=1"
			url += "&date-range-start=2022-12-19";//+Penanggalan().mingguSekarang
			url += "&date-range-end=2023-01-31";//+Penanggalan().kemarin
			url += (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			*/
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.salesdata = this.processBarChart2(result.data.data, 'ProductName', 'SalesVolume', false, 'Period', 1000, 2, FuelColor,
						false, false, false, true, false, false, false, true)
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.salesWeeklySatgas = false;
			})
        },

		async getSatgasPic() {
			//GET CONTACT PIC SATGAS
			//let url =Config().apiURL+"/v1/contact/satgas"
			this.loading.pic = true;
			let url =Config().apiURL+"/contact/satgas"
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.satgasPic = result.data.data;
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.pic = false;
			})
		},

		async getFilePath() {
			//GET File Path
			let url =Config().apiURL+"/v1/contact/sprintFile"
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data) {
					this.filePath = result.data.data[0].Value;
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {

			})
		},

		sprintPDF() {
			if(this.filePath == '') {
				this.$alert('Please wait, loading file...', 'Info', {
					confirmButtonText: 'OK',
					callback: action => {

					}
				});
			} else {
				console.log('this.filePath : ' + this.filePath)
				window.open(this.filePath, '_blank').focus();
			}
		},

		generateStatusGroups(data) {
			var groups = {};
			data.forEach(function (entry) {
				var status = entry.Status || "NOT UPDATE";
				//var status = entry.Status;
				groups[status] = (groups[status] || 0) + 1;
			});

			let statusGroupPie= Object.keys(groups).map(function (status) {
				return { Status: status, Cnt: groups[status] };
			});

			let Rainbow2=['#67C23A','#F56C6C','#E6A23C','#8896B3']
			let warna=[]

			for (let i = 0; i < statusGroupPie.length; i++) {
				let statusName = statusGroupPie[i].Status
				if(statusName == 'NORMAL')
					warna[statusName] = '#67C23A';
				else if(statusName == 'CRITICAL')
					warna[statusName] = '#F56C6C';
				else if(statusName == 'BELUM OPERASIONAL')
					warna[statusName] = '#F56C6C';
				else
					warna[statusName] = '#E6A23C';

				//warna[statusName] = Rainbow2[i];
			}

			/*
			warna['NORMAL'] = '#67C23A'
			warna['CRITICAL'] = '#F56C6C'
			warna['BELUM OPERASIONAL'] = '#F56C6C'
			*/

			this.statusgrouppie = this.processPieChart(statusGroupPie, "Cnt", "Status", 1, 2, warna);
		},

		generateStatusATGGroups(data) {
			var groups = {};
			data.forEach(function (entry) {
				var status = entry.StatusATG || "OFFLINE";
				//var status = entry.StatusATG;
				groups[status] = (groups[status] || 0) + 1;
			});

			let statusATGGroupPie= Object.keys(groups).map(function (status) {
				return { StatusATG: status, Cnt: groups[status] };
			});

			let Rainbow2=['#67C23A','#F56C6C','#8896B3']
			var warna=[]

			for (let i = 0; i < statusATGGroupPie.length; i++) {
				let statusName = statusATGGroupPie[i].StatusATG

				if(statusName == 'ONLINE')
					warna[statusName] ='#67C23A';
				else if(statusName == 'OFFLINE')
					warna[statusName] = '#E6A23C';
				else if(statusName == 'BELUM OPERASIONAL')
					warna[statusName] = '#F56C6C';
				else
					warna[statusName] = '#E6A23C';

				//warna[statusName] = Rainbow2[i];
			}

			/*
			warna['ONLINE'] = '#67C23A'
			warna['OFFLINE'] = '#E6A23C'
			warna['BELUM OPERASIONAL'] = '#F56C6C'
			*/
			//console.log(JSON.stringify(data))
			this.statusatggrouppie = this.processPieChart(statusATGGroupPie, "Cnt", "StatusATG", 1, 2, warna);
		},

		async getStatusPekerjaFitUnfit() {
			//GET STATUS PEKERJA FIT & UNFIT
			let station = this.$route.query.station
			let url =Config().apiURL + '/v1/vendor/absentkjppiechart?'
			url +='&station='+station
			this.loading.piechartstatuspekerja = true
			AxiosWithJar().get(url)
			.then((response)=>{
				if(response.data.data) {
					//console.log(JSON.stringify(response.data))
					let data = response.data.data
					this.piechartstatuspekerjadata = data

					this.pieChartStatusPekerjaData();
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				//this.loading.salesmodular = false;
				this.loading.piechartstatuspekerja = false
			})
		},

		pieChartStatusPekerjaData()
        {
			let Rainbow2=['#F56C6C','#67C23A','#E6A23C','#8896B3']
			var warna=[]
			let data = this.piechartstatuspekerjadata

			for (let i = 0; i < data.length; i++) {
				let conditionName = (data[i].Condition).toLowerCase();

				if(conditionName == 'fit')
					warna[conditionName] = '#67C23A';
				else if(conditionName == 'unfit' || conditionName == 'un fit')
					warna[conditionName] = '#F56C6C';
				else
					warna[conditionName] = '#E6A23C';

				//warna[conditionName] = Rainbow2[i];
			}

			/*
			warna['fit'] = '#67C23A'
			warna['unfit'] = '#F56C6C'
			warna['covid'] = '#F56C6C'
			*/
			//console.log(JSON.stringify(data))
			let result = this.processPieChart(this.piechartstatuspekerjadata, "cnt", "Condition", 1, 2, warna);
			this.piechartpekerja = result;
			//return result;
        },

		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		handleTablePICResize() {
			// Fungsi untuk menangani perubahan ukuran layar
			this.getTablePICHeight();
		},

		getTablePICHeight() {
			const screenHeight = window.innerHeight;
			this.tablePICHeight = screenHeight - 200;
		},

		morValue(val) {
			return val == '0' ? '' : val //val //parseInt(val) < 1 ? '' : val
		}
    },
	created() {
		window.addEventListener("resize", this.handleTablePICResize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleTablePICResize);
	}
}
</script>
<style>
    .peta.gmap{ position:relative; overflow: hidden; }
    .peta.gmap .search{ position: absolute; left:0px; bottom:0px; top:60px; width:300px; display:flex; flex-direction:column-reverse; overflow: hidden;}
    .peta.gmap .search .input,.peta.gmap .search .result { width:100%; z-index:1; position:relative; padding: 15px; font-size: 12px; }
    .peta.gmap .search .input{ padding: 0px 0px 15px 15px; width: 100%;    }
    .peta.gmap .search .result{ margin: 15px 15px 10px; width: 100%; border-radius: 5px; padding:0px;    }
    .peta.gmap .search .result ul{ background: linear-gradient(45deg,#c7251c 19%,transparent); list-style-type: none; border-radius: 10px; margin-bottom: 10px; overflow-y: scroll; overflow-x: hidden; max-height:220px; width: 285px;}
    .peta.gmap .search .result ul li{ padding:5px 10px;  white-space:nowrap; color:#e1e1e1; cursor: pointer;}
    .peta.gmap .search .result ul li:nth-child(2n+2){ background: #146db7; color:#fff; }
    .peta.gmap .search .input input  {
        width: 100%;
        padding: 10px;
        background: none;
        border: 1px #146db7 solid;
        border-radius: 5px;
        backdrop-filter: saturate(200%) blur(10px);
        background-color: rgba(255, 255, 255, 0.8) !important;

    }
    .peta.gmap .search .input input:focus { border:1px red solid;  outline: none;}

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dialog-pic-satgas {
	width:95% !important;
	max-width: 600px !important;
	margin-top: 50px !important;
	margin-bottom: 50px !important;
}

.el-table .cell {
	word-break: break-word !important;
}

.table-station-satgas table tr {
    cursor: pointer;
}
</style>
